import { Grid, IconButton, Tooltip } from '@mui/material'

import { useCallback, useEffect, useState } from 'react'
import { MdArrowBack } from 'react-icons/md'
import Programa from '../../../components/Programa/Programa'
import PrimeTable from '../../../components/PrimeTable'
import VisualizaResposta from './VisualizaResposta'

const RespostaQuestionarioPublico = () => {
  const [tela, setTela] = useState('lista')
  const [ferramentas, setFerramentas] = useState()
  const [dados, setDados] = useState(null)

  const voltar = useCallback(() => {
    setTela('lista')
  }, [])

  useEffect(() => {
    switch (tela) {
      case 'opcoes':
        setFerramentas(
          <Tooltip title="Voltar">
            <IconButton onClick={voltar}>
              <MdArrowBack />
            </IconButton>
          </Tooltip>,
        )
        break
      default:
        break
    }
  }, [tela, voltar])

  const handleClick = (linha) => {
    setDados(linha)
    setTela('opcoes')
  }

  return (
    <Programa codigo="CtrlRespostaQuestionario" ferramentas={ferramentas}>
      {tela === 'opcoes' ? (
        <VisualizaResposta dados={dados} />
      ) : (
        <Grid item xs={12}>
          <PrimeTable
            head={['Resposta', 'Questionário', 'Data', 'Paciente']}
            line={(item) => [item[0], item[1], item[2], item[5]]}
            collumnsDateHour={[2]}
            action="lista"
            codigo="CtrlRespostaQuestionario"
            onRowSelect={handleClick}
          />
        </Grid>
      )}
    </Programa>
  )
}

export default RespostaQuestionarioPublico
